import { GET_ROOM_DATA } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_ROOM_DATA.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_ROOM_DATA.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case GET_ROOM_DATA.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
